import { useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useAuth } from '../contexts/AuthContext';

const OnboardingTour = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Check if user has already seen the tour
    const hasSeenTour = localStorage.getItem('hasSeenOnboardingTour');

    if (!hasSeenTour) {
      const steps = [
        {
          element: '[data-testid="dashboard"]',
          popover: {
            title: 'Welcome to CatSoftwares!',
            description: 'This is your agency command center. Let us show you around.',
            side: "left",
            align: 'start'
          }
        },
        ...(user && !user.is_verified ? [{
          element: '[data-testid="verification-alert"]',
          popover: {
            title: 'Verify Your Account',
            description: 'Make sure to verify your email to unlock all features and secure your account.',
            side: "bottom",
            align: 'start'
          }
        }] : []),
        {
          element: '[data-testid="total-income-card"]',
          popover: {
            title: 'Track Your Revenue',
            description: 'See your total earnings from completed projects at a glance.',
            side: "bottom",
            align: 'start'
          }
        },
        {
          element: '[data-testid="active-projects-card"]',
          popover: {
            title: 'Manage Your Work',
            description: 'Keep an eye on how many projects you have currently active.',
            side: "bottom",
            align: 'start'
          }
        },
        {
          element: '[data-testid="quick-action-add-client"]',
          popover: {
            title: 'Add Your First Client',
            description: 'Start by adding a client to manage their projects and invoices.',
            side: "top",
            align: 'start'
          }
        },
        {
          element: '[data-testid="quick-action-create-project"]',
          popover: {
            title: 'Launch a Project',
            description: 'Create your first project, set milestones, and track progress.',
            side: "top",
            align: 'start'
          }
        },
        {
          element: '[data-testid="sidebar-nav"]',
          popover: {
            title: 'Navigation',
            description: 'Use the sidebar to jump between Projects, Clients, Finances, and Team management.',
            side: "right",
            align: 'start'
          }
        },
      ];

      const driverObj = driver({
        showProgress: true,
        steps: steps,
        onDestroyed: () => {
          localStorage.setItem('hasSeenOnboardingTour', 'true');
        }
      });

      // Start the tour after a short delay to ensure components are rendered
      const timer = setTimeout(() => {
        driverObj.drive();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user]); // Add user to dependencies

  return null;
};

export default OnboardingTour;
